import React from "react";
import { isEmpty, map, size } from "lodash";
import { useNavigate } from "react-router-dom";
import playlistStore from "../../zustand/playlist.store";
import ThumbNail from "../../components/thumbNail/ThumbNail";
import { MEDIA_URL } from "../../axios";
import MobileHeader from "../components/MobileHeader";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import styles from "./MobilePlaylists.module.scss";

const MobilePlaylists = () => {
  const { playlists, isLoading } = playlistStore();
  const navigate = useNavigate();

  const handleSchedule = (e, playlistId) => {
    e.stopPropagation();
    navigate(`/mobile/schedule/create?playlist=${playlistId}`);
  };

  const handleView = (id) => navigate(`/mobile/playlists/view/${id}`);

  const rightAction = (
    <button className={styles.addBtn} onClick={() => navigate("/mobile/playlists/new")}>
      <Icons type={ICONS.PLUS} />
    </button>
  );

  return (
    <div className={styles.page}>
      <MobileHeader title="My Playlists" rightAction={rightAction} />
      {isLoading ? (
        <div className={styles.loader}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className={styles.skeletonItem}>
              <div className={`${styles.skeletonThumb} ${styles.skeletonPulse}`} />
              <div className={styles.skeletonInfo}>
                <div className={`${styles.skeletonName} ${styles.skeletonPulse}`} />
                <div className={`${styles.skeletonCount} ${styles.skeletonPulse}`} />
              </div>
            </div>
          ))}
        </div>
      ) : isEmpty(playlists) ? (
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>
            <Icons type={ICONS.MY_PLAYLIST} />
          </div>
          <p className={styles.emptyTitle}>No playlists yet</p>
          <p className={styles.emptySubtext}>Create your first playlist to get started</p>
          <button className={styles.createBtn} onClick={() => navigate("/mobile/playlists/new")}>Create Playlist</button>
        </div>
      ) : (
        <div className={styles.list}>
          {map(playlists, (pl) => (
            <div key={pl.id} className={styles.item} onClick={() => handleView(pl.id)}>
              <div className={styles.thumb}>
                <ThumbNail name={pl.name} color={pl.color} hasImage={!!pl.image} imgSrc={`${MEDIA_URL}/playlist_images/${pl.image}`} imageFileName={pl.image} />
              </div>
              <div className={styles.info}>
                <p className={styles.name}>{pl.name}</p>
                <p className={styles.count}>{size(pl.songs)} songs</p>
              </div>
              <button className={styles.scheduleBtn} onClick={(e) => handleSchedule(e, pl.id)}>
                <Icons type={ICONS.MY_SCHEDULE} fill="#949494" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobilePlaylists;
